/** Demo ticker shown in the beta restriction notice on stock analysis. */
export const BETA_DEMO_TICKER = 'PLTR';

export type StockAnalysisLocationState = {
  showBetaRestrictionNotice?: boolean;
};
